// Centralized application configuration
const ENVIRONMENT = process.env.NODE_ENV || 'development';

export const config = {
    apiUrl: ENVIRONMENT === 'production'
        ? process.env.REACT_APP_API_URL || 'api/v1'
        : process.env.REACT_APP_API_URL || '/api/v1',
    environment: ENVIRONMENT,
    isDevelopment: ENVIRONMENT === 'development',
    isProduction: ENVIRONMENT === 'production'
};
